import { ModalTitle } from '@strava/ui/Modal';
import React from 'react';

const TermsOfService = () => {
  return <ModalTitle id="onboarding-step-title">terms_of_service</ModalTitle>;
};

export default TermsOfService;
